export const header = {
    background: 'rgb(235, 241, 250)',
    color: '#0D1B2A',
    fontWeight: '600',
    fontSize: '12px',
    letterSpacing: '0.6px',
    textTransform: 'uppercase',
    padding: '14px 16px',
    whiteSpace: 'nowrap',
};
